import React from 'react'
import {
  Form,
  Loading,
  useGetOne,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import { Box, Grid, Typography, Button, useMediaQuery } from '@mui/material'
import axios from 'axios'
import { isNil, map, split, template } from 'lodash/fp'
import { Partner } from 'types'

const env = process.env['REACT_APP_ENV']
const urls = {
  prd: 'https://api-b2b-v2.terashite.jp',
  stg: 'https://api-b2b-v2-stg.terashite.jp',
  int: 'https://api-b2b-v2-int.dev.terashite.jp',
  dev: 'https://api-b2b-v2.dev.terashite.jp',
  exp: 'https://api-b2b-v2-exp.dev.terashite.jp'
}
const url = isNil(process.env['API_LOCAL'])
  ? urls[env as keyof typeof urls]
  : 'http://localhost:14001'

export const SolarApprovalForm: React.FC<{
  partner: string
  id: string
}> = ({ partner, id }) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const { data, isLoading } = useGetOne<Partner>('partners', { id: partner })
  const translate = useTranslate()
  const redirect = useRedirect()
  const notify = useNotify()
  React.useEffect(() => {
    document.title = translate('resources.title')
  })
  const onClick = (): void => {
    notify('resources.solarApproval.waiting', { autoHideDuration: null })
    axios({
      url: `${url}/partner-notification-report/v1/solarApproval/${partner}/${id}`,
      method: 'GET'
    })
      .then(() => {
        notify('resources.solarApproval.waiting', { autoHideDuration: 0 })
        redirect(`/solarApproval/${partner}/${id}/complete`)
      })
      .catch(() => {})
  }
  if (isLoading) return <Loading />
  const { name } = data ?? { name: '' }
  return (
    <Form>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ marginLeft: '0.5em' }}>
            <picture>
              <img
                src="/siteLogoS.svg"
                width={isDesktop ? '20%' : '80%'}
                alt="terashite S"
              />
            </picture>
          </Box>
          <Box
            sx={{
              backgroundColor: '#fff7e1',
              paddingTop: '2em',
              paddingBottom: '3em'
            }}>
            <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
              <Grid
                container
                justifyContent="center"
                spacing={2}
                sx={{
                  marginTop: '0.1em'
                }}>
                {
                  // @ts-expect-error ts(2339)
                  map.convert({ cap: false })((line: string, index: number) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sx={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <Typography variant={isDesktop ? 'h6' : 'body1'}>
                        {line}
                      </Typography>
                    </Grid>
                  ))(
                    split('\n')(
                      template(translate('resources.solarApproval.title'))({
                        partner: name
                      })
                    )
                  )
                }
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={onClick}
                    size="large"
                    variant="contained"
                    sx={{ px: '5em' }}>
                    <Typography variant="h6">
                      {translate('resources.solarApproval.button')}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}
export const SolarApprovalForm2: React.FC<{
  partner: string
  id: string
  hash: string
}> = ({ partner, id, hash }) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const { data, isLoading } = useGetOne<Partner>('partners', { id: partner })
  const translate = useTranslate()
  const redirect = useRedirect()
  const notify = useNotify()
  React.useEffect(() => {
    document.title = translate('resources.title')
  })
  const onClick = (): void => {
    notify('resources.solarApproval.waiting', { autoHideDuration: null })
    axios
      .post(
        `${url}/partner-notification-report/v1/solarApproval2/${partner}/${id}/${hash}`,
        {
          dryRun: !isNil(process.env['DRYRUN'])
        }
      )
      .then(() => {
        notify('resources.solarApproval.waiting', { autoHideDuration: 0 })
        redirect(`/solarApproval/${partner}/${id}/complete`)
      })
      .catch(() => {})
  }
  if (isLoading) return <Loading />
  const { name } = data ?? { name: '' }
  return (
    <Form>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ marginLeft: '0.5em' }}>
            <picture>
              <img
                src="/siteLogoS.svg"
                width={isDesktop ? '20%' : '80%'}
                alt="terashite S"
              />
            </picture>
          </Box>
          <Box
            sx={{
              backgroundColor: '#fff7e1',
              paddingTop: '2em',
              paddingBottom: '3em'
            }}>
            <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
              <Grid
                container
                justifyContent="center"
                spacing={2}
                sx={{
                  marginTop: '0.1em'
                }}>
                {
                  // @ts-expect-error ts(2339)
                  map.convert({ cap: false })((line: string, index: number) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sx={{ display: 'flex', justifyContent: 'center' }}>
                      {' '}
                      <Typography variant={isDesktop ? 'h6' : 'body1'}>
                        {line}
                      </Typography>
                    </Grid>
                  ))(
                    split('\n')(
                      template(translate('resources.solarApproval2.title'))({
                        partner: name
                      })
                    )
                  )
                }
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    onClick={onClick}
                    size="large"
                    variant="contained"
                    sx={{ px: '5em' }}>
                    <Typography variant="h6">
                      {translate('resources.solarApproval2.button')}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}
export const SolarApprovalCompleteForm: React.FC = () => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  React.useEffect(() => {
    document.title = translate('resources.title')
  })
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <picture>
            <img
              src="/siteLogoS.svg"
              width={isDesktop ? '20%' : '80%'}
              alt="terashite S"
            />
          </picture>
        </Box>
        <Box
          sx={{
            backgroundColor: '#fff7e1',
            paddingTop: '2em',
            paddingBottom: '3em'
          }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              {
                // @ts-expect-error ts(2339)
                map.convert({ cap: false })((text: string, index: number) => (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant={isDesktop ? 'h6' : 'body1'}>
                      {text}
                    </Typography>
                  </Grid>
                ))(
                  split('\n')(
                    `${translate('resources.solarApproval.thanksFooter')}`
                  )
                )
              }
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
